(function(){
  var btn=document.getElementById('osi-menu-btn');
  var closeBtn=document.getElementById('osi-menu-close');
  var overlay=document.getElementById('osi-menu-overlay');
  if(!btn||!overlay)return;
  function openMenu(){document.body.classList.add('osi-menu-open');overlay.removeAttribute('aria-hidden');btn.setAttribute('aria-expanded','true');if(closeBtn)closeBtn.focus();}
  function closeMenu(){document.body.classList.remove('osi-menu-open');overlay.setAttribute('aria-hidden','true');btn.setAttribute('aria-expanded','false');btn.focus();}
  btn.addEventListener('click',openMenu);
  if(closeBtn)closeBtn.addEventListener('click',closeMenu);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&document.body.classList.contains('osi-menu-open'))closeMenu();});
  overlay.querySelectorAll('a').forEach(function(a){a.addEventListener('click',closeMenu);});
})();
(function(){
  var facade=document.getElementById('osi-hero-facade');
  if(!facade)return;
  var vimeoId=facade.dataset.vimeoId;
  if(!vimeoId)return;
  function loadVideo(){
    var iframe=document.createElement('iframe');
    iframe.src='https://player.vimeo.com/video/'+vimeoId+'?autoplay=1&muted=1&loop=1&controls=0&background=1';
    iframe.className='osi-hero__iframe';
    iframe.setAttribute('frameborder','0');
    iframe.setAttribute('allow','autoplay; fullscreen');
    var poster=facade.querySelector('.osi-hero__poster');
    if(poster)poster.style.opacity='0';
    facade.appendChild(iframe);
    facade.removeAttribute('data-vimeo-id');
  }
  facade.addEventListener('click',loadVideo,{once:true});
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      if(entries[0].isIntersecting){setTimeout(loadVideo,200);io.disconnect();}
    },{threshold:0.5});
    io.observe(facade);
  }
})();
